import { FeConfigType } from "config/config";

/** Serialize a dashboard-style filter for GraphQL `filter` variables. */
export function serializeGraphFilter(filter: unknown): string | null {
    if (filter == null) {
        return null;
    }
    return typeof filter === "string" ? filter : JSON.stringify(filter);
}

/** A single field/op/value comparison filter. */
export interface ScopeComparison {
    field: string;
    op: string;
    value: string;
}

/**
 * Build a project/bundle scope filter OBJECT from canvas location props (the
 * unserialized form, so it can be AND-combined with other comparisons — e.g. a
 * per-template count filter). Returns null for the workspace scope or an
 * unresolved locationId.
 */
export function locationScopeFilterObject(
    location?: FeConfigType,
    locationId?: string
): ScopeComparison | null {
    if (!locationId || location === "workspace") {
        return null;
    }
    const field = location === "project" ? "project_id" : "bundle_id";
    return { field, op: "eq", value: locationId };
}

/** Build a project/bundle scope filter (serialized) from canvas location props. */
export function locationScopeFilter(
    location?: FeConfigType,
    locationId?: string
): string | null {
    const scope = locationScopeFilterObject(location, locationId);
    return scope ? JSON.stringify(scope) : null;
}

/** Resolve the effective GraphQL filter from explicit filter or location scope. */
export function resolveGraphFilter(
    filter: unknown | undefined,
    location?: FeConfigType,
    locationId?: string
): string | null {
    const explicit = serializeGraphFilter(filter);
    if (explicit != null) {
        return explicit;
    }
    return locationScopeFilter(location, locationId);
}

/** True when data was scoped by an explicit filter prop (not location-derived scope). */
export function isPrefilteredScope(filter: unknown | undefined): boolean {
    return filter != null && serializeGraphFilter(filter) != null;
}
